import { nl } from 'date-fns/locale';

export const formatRelativeConfig = {
  weekStartsOn: 1,
  locale: nl,
};
